import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class AccordionSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'accordion');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', ['main', 'content', 'header']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content', 'header']),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
            this.fontTransformField('font.transform'),
            this.backgroundColorField('background.color', ['content']),

            this.sizeNumberField('border.width', 'px'),
            this.borderColorField('border.color', ['main', 'content']),

            
            this.fontColorComboField('active.font.color', ['accordion', 'header', 'main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.backgroundColorField('active.background.color', ['accordion', 'header', 'content'], this.preset('active-background-color', 'main')),
            this.fontColorComboField('hover.font.color', ['accordion', 'header', 'main', 'content'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['accordion', 'header', 'content'], this.preset('hover-background-color', 'main')),
            
        ];
    }

}
